import React from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import SearchIcon from "@material-ui/icons/Search";
import InsertInvitationOutlinedIcon from "@material-ui/icons/InsertInvitationOutlined";
import GroupAddOutlinedIcon from "@material-ui/icons/GroupAddOutlined";

import { Card } from "react-bootstrap";
import MuiAlert from "@material-ui/lab/Alert";

import {
  TablePagination,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  makeStyles,
  Typography,
  InputBase,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Snackbar,
  CircularProgress,
} from "@material-ui/core";
import { fetchCoachClients } from "../apis";

// const GET_CLIENTS_LIST = gql`
//   query Query(
//     $getJobSeekerListByCoachPageNo: Int
//     $getJobSeekerListByCoachLimit: Int
//     $getJobSeekerListByCoachSearchText: String
//   ) {
//     getJobSeekerListByCoach(
//       pageNo: $getJobSeekerListByCoachPageNo
//       limit: $getJobSeekerListByCoachLimit
//       searchText: $getJobSeekerListByCoachSearchText
//     ) {
//       jobSeekerList {
//         id
//         firstName
//         lastName
//         email
//         cellPhone
//         userStageJsonString
//       }
//       jobSeekerCount
//       pageNo
//     }
//   }
// `;

// // add client
// const REGISTER_USER = gql`
//   mutation Mutation(
//     $addJobSeekerFirstName: String!
//     $addJobSeekerLastName: String!
//     $addJobSeekerEmail: String!
//     $addJobSeekerPassword: String!
//   ) {
//     addJobSeeker(
//       firstName: $addJobSeekerFirstName
//       lastName: $addJobSeekerLastName
//       email: $addJobSeekerEmail
//       password: $addJobSeekerPassword
//     ) {
//       code
//       success
//       message
//     }
//   }
// `;
// const SEND_INVITATION = gql`
//   mutation SendInvitationMutation(
//     $sendInvitationEmail: String
//     $sendInvitationFirstName: String
//     $sendInvitationLastName: String
//   ) {
//     sendInvitation(
//       email: $sendInvitationEmail
//       firstName: $sendInvitationFirstName
//       lastName: $sendInvitationLastName
//     ) {
//       code
//       success
//       message
//     }
//   }
// `;

// css
const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  table: {
    minWidth: 1050,
  },
  tableHeadCell: {
    fontSize: "18px",
  },
  tableRowCell: {
    fontSize: "14px",
    borderBottom: "none",
    lineHeight: "40px",
    align: "left",
  },
  dropdown: {
    position: "absolute",
    top: 28,
    right: 0,
    left: 0,
    zIndex: 1,
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#f2f2f2",
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    fontSize: "14px",
  },
  inputInput: {
    padding: theme.spacing(1.5, 1.5, 1.5, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));
// end of css

const headers = ["Client Name", "Email", "Phone", "Stage"];

// let rows = [];
// let count;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export function ClientListTable({ setSelectedUser, user }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([])
  const [count, setCount] = React.useState(0)

console.log("rnrnrnrnrnrn", user)
  const fetchClients = async (p, limit) => {
    let data = await fetchCoachClients(user._id, p, limit)
console.log("data:-=-=-=", data)
    setCount(data.count)
    if (data.users && data.users.length > 0) {
      let newRows = data.users.map((key) => {
        // Stage
        let lastSelectedStage = "";
        if (key.userStageJsonString) {
          let stagesList = JSON.parse(key.userStageJsonString);
          Object.keys(stagesList).map((stages) => {
            if (typeof stagesList[stages] === "object") {
              Object.keys(stagesList[stages]).map((stage) => {
                if (stagesList[stages][stage]) {
                  lastSelectedStage = stage;
                }
              });
            }
            if (typeof stagesList[stages] === "boolean") {
              if (stagesList[stages]) {
                lastSelectedStage = stages;
              } else {
                if (!lastSelectedStage.length)
                  lastSelectedStage = "No stage selected";
              }
            }
          });
        } else {
          lastSelectedStage = "No stage selected";
        }
        let phone = "";
        if (key.cellPhone && key.cellPhone !== "0") {
          phone = key.cellPhone;
        }
        return {
          id: key._id,
          name: key.firstName + " " + key.lastName,
          email: key.email,
          phone: phone || "N/A",
          stage: lastSelectedStage,
        };
      });

      setRows([...newRows])
    }
  }

  React.useEffect(() => {
    fetchClients(page, rowsPerPage)
  }, [])

  // const { data, refetch } = useQuery(GET_CLIENTS_LIST, {
  //   variables: {
  //     getJobSeekerListByCoachPageNo: page,
  //     getJobSeekerListByCoachLimit: rowsPerPage,
  //     getJobSeekerListByCoachSearchText: search,
  //   },
  // });

  const [snackBarText, setSnackBarText] = React.useState("");
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);


  const handleSelectedUser = (id) => {
    setSelectedUser(id);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchClients(newPage, rowsPerPage)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const classes = useStyles();

  // if (typeof data === "object") {
  // }

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarOpen(false);
  };



  return (
    <Card className="shadow-sm">
      <Card.Body>
        <Grid container driection="column" className="px-5">
          <Grid item>
            <Snackbar
              open={snackBarOpen}
              autoHideDuration={5000}
              color="danger"
              onClose={handleSnackBarClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Alert
                onClose={handleSnackBarClose}
                style={{ fontSize: "16px" }}
                severity={snackbarSeverity}
              >
                {snackBarText}
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>

        <TableContainer className="mt-10">
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headers.map((item, index) => (
                  <TableCell
                    key={index}
                    align="left"
                    classes={{ root: classes.tableHeadCell }}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <StyledTableRow
                  // hover={true}
                  // selected={true}
                  style={{ cursor: "pointer" }}
                  key={index}
                >
                  <TableCell
                    classes={{
                      root: classes.tableRowCell,
                    }}
                    component="th"
                    scope="row"
                    align="left"
                    onClick={() => {
                      handleSelectedUser(row.id);
                    }}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.email}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.phone}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    <Typography class="text-capitalize">
                      {row.stage.replace(/([A-Z])/g, " $1").trim()}
                    </Typography>
                  </TableCell>
                  {/* <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    <Dropdown as={ButtonGroup}>
                      <Dropdown.Toggle id="dropdown-basic" className="border">
                        {" actions "}
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          lineHeight: 0,
                          left: -100,
                          top: 40,
                        }}
                      >
                        <Dropdown.Item
                          href="#"
                          className="p-6"
                          style={{ fontSize: "14px" }}
                        >
                          Block
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#"
                          className="p-6"
                          style={{ fontSize: "14px" }}
                        >
                          Unblock
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </TableCell>
                 */}
                </StyledTableRow>
              ))}
            </TableBody>
            <TablePagination
              count={count}
              page={page}
              onChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Table>
        </TableContainer>
      </Card.Body>
    </Card>
    // </Box>
  );
}
